export default __webpack_public_path__ + "static/media/bryce.a3da660a.jpg";